import OneSingleChat from "./OneSingleChat";

export default OneSingleChat;